import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export type IVideoTopic = {
  video_id: number;
  last_position: number;
  completed: boolean;
};

export const ProgressUpdateVideoLessonsSlice = createSlice({
  name: "ProgressUpdateVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    ProgressUpdateVideoLesson: (state, action) => {
      state.isLoading = true;
    },

    successProgressUpdateVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureProgressUpdateVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearProgressUpdateVideoLessons: (state) => {
      state.data = {};
    },
  },
});

export const {
  ProgressUpdateVideoLesson,
  successProgressUpdateVideoLessons,
  failureProgressUpdateVideoLessons,
  clearProgressUpdateVideoLessons,
} = ProgressUpdateVideoLessonsSlice.actions;

export default ProgressUpdateVideoLessonsSlice.reducer;
